import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  accounts: localStorage.getItem('accounts') && JSON.parse(localStorage.getItem('accounts'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/accounts/index.js